// Comment form ajax
import loadComments from "./load-comments";
import totalComments from "./total-comments";

const initCommentFormAjax = (formContent) => {
    let commentform = formContent.querySelector('.comment-form');
    let respond = formContent.querySelector('.comment-respond');

    commentform.addEventListener('submit', event => {
        event.preventDefault();

        // Get all field data from the form and returns a FormData object
        let data = new FormData(commentform);
        // Convert to a query string
        let queryString = new URLSearchParams(data).toString();

        if (queryString.length > 0) {
            let xhttp = new XMLHttpRequest();

            // Response
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    if (this.responseText != 0) {
                        respond.innerHTML = this.responseText;
                        loadComments();
                        totalComments();
                    } else {
                        respond.innerHTML = "<div class='comment-error' > Erreur ?</div>";
                    }

                } else {
                    respond.innerHTML = "<div class='comment-error' >" + this.responseText + "</div>";
                }

            };

            xhttp.open("POST", pokaa.ajaxurl, true);
            xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            xhttp.send("action=submit_comment&" + queryString);
        }

    });

}

const panelCommentsReset = () => {

    // Reset Comment form ajax
    const panelComments = document.querySelectorAll('.panel-comment');
    if (panelComments !== null) {

        panelComments.forEach(panelComment => {

            let close = panelComment.querySelector('.panel-header .panel-close');
            let comments = document.getElementById('panel-comments');

            close.addEventListener('click', () => {

                let xhttp = new XMLHttpRequest();
                let commentForm = panelComment.querySelector('.comment-respond .comment-form');
                let respond = panelComment.querySelector('.form-content');

                if (commentForm == null) {
                    // Response
                    xhttp.onreadystatechange = function () {
                        if (this.readyState == 4 && this.status == 200) {
                            if (this.responseText != 0) {
                                respond.innerHTML = this.responseText;
                                initCommentFormAjax(respond);
                            } else {
                                respond.innerHTML = "<div class='comment-error' > Erreur ?</div>";
                            }

                        } else {
                            respond.innerHTML = "<div class='comment-error' >" + this.responseText + "</div>";
                        }

                    };

                    xhttp.open("POST", pokaa.ajaxurl, true);
                    xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                    xhttp.send("action=reload_comment_form&postid=" + comments.getAttribute('data-postid'));
                }

            });
        });

    }
}

const initAjaxComment = () => {
    const formContents = document.querySelectorAll('.form-content');
    if (formContents !== null) {

        formContents.forEach(formContent => {
            initCommentFormAjax(formContent);
        });

        panelCommentsReset();
    }
}
export default initAjaxComment;